import { P, SvgIcon } from '@salecycle/ui-component-library';
import { WorkflowBox } from '../../WorkflowBox/WorkflowBox';
import { WorkflowBoxHeader } from '../../WorkflowBox/WorkflowBoxHeader';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useWorkflowForm } from '../../../contexts/CampaignWorkflowFormContext';
import { WorkflowContent } from '../../WorkflowBox/WorkflowContent';
import { useDrawer } from '../../../state/Drawer/hooks/useDrawer';
import { ConfirmChangeBrandModal } from './components/BranchConfirmDeletionModal';
import { WorkflowBoxFooter } from '../../WorkflowBox/WorkflowBoxFooter';
import { useBranches } from '../../../state/Branches/hooks/useBranches';

export const BranchControlsWorkflow = ({ id }) => {
  const { t } = useTranslation('campaigns');

  const { actions, getIsFocused, getIsTouched } = useWorkflowForm();
  const { drawer, openDrawer, closeDrawer, removeConfigNode } = useDrawer();
  const { areBranchesLoadedFromServer } = useBranches();

  const [isBranchModalOpen, setBranchModal] = useState(false);

  const removeWorkflow = useCallback(() => {
    setBranchModal(true);
    closeDrawer();
    actions.setFocused('branchControl', false);
    actions.setTouched('branchControl', false);
  }, [closeDrawer, actions]);

  const onOpenConfiguration = useCallback(() => {
    openDrawer(id, 'branch-controls');
    actions.setFocused('branchControl', true);
  }, [openDrawer, id, actions]);

  const isFocused = getIsFocused('branchControl');
  const hasSettingsSet = useMemo(() => !isFocused && getIsTouched('branchControl'), [getIsTouched, isFocused]);

  return (
    <>
      <WorkflowBox variant={'Default'} id={id} ariaLabel="Branch controls workflow">
        <WorkflowBoxHeader
          icon={<SvgIcon name={'split'} size="32" />}
          title={t('onsite.editor.workflow.branchControls.workflow.heading')}
          actionsMenuAriaLabel="Edit Branch Settings"
          onOpenConfiguration={onOpenConfiguration}
          onRemove={removeWorkflow}
          removeMargin={isFocused}
        />
        <WorkflowContent showValidationWarning={false}>
          {isFocused ? null : (
            <P>
              {hasSettingsSet || areBranchesLoadedFromServer
                ? t('onsite.editor.workflow.branchControls.workflow.completeBody')
                : t('onsite.editor.workflow.branchControls.workflow.defaultBody')}
            </P>
          )}
        </WorkflowContent>
        <WorkflowBoxFooter
          show={drawer.type === 'branch-controls' && drawer.open}
          hasSettingsSet={hasSettingsSet}
          openConfigurationButtonLabel={t('onsite.editor.workflow.branchControls.workflow.openConfigurationButton')}
          openConfigurationButtonAriaLabel={t('onsite.editor.workflow.branchControls.workflow.selectContentAria')}
          onOpenConfiguration={onOpenConfiguration}
          removeGap={isFocused}
        />
      </WorkflowBox>
      <ConfirmChangeBrandModal
        wholeBranches
        openModal={isBranchModalOpen}
        setIsModalOpen={setBranchModal}
        confirmModal={removeConfigNode}
      />
    </>
  );
};
